export const LATITUDE = 'latitude';
export const LONGITUDE = 'longitude';
export const ICON = 'icon';
export const ICON_SIZE = 'iconSize';
export const ICON_SIZE_X = 'x';
export const ICON_SIZE_Y = 'y';
export const ID = 'id';

export function areEqual(x, y) {
  return x[LATITUDE] === y[LATITUDE] && x[LONGITUDE] === y[LONGITUDE];
}

export default function MapPositionModel({
  [LATITUDE]: latitude,
  [LONGITUDE]: longitude,
  [ICON]: icon,
  [ICON_SIZE]: size,
  [ID]: id,
}) {
  const iconSize = size || { [ICON_SIZE_X]: 19, [ICON_SIZE_Y]: 33 };
  return {
    [LATITUDE]: latitude,
    [LONGITUDE]: longitude,
    [ICON]: icon,
    [ICON_SIZE]: iconSize,
    [ID]: id,
  };
}
